import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { SaveVesselFormRequest, UploadDocumentRequest } from "../models/document-management.models";

@autoinject
export class DocumentManagementApi {

    public documentManagementApi: string = `${this.configService.config.urls.documentManagementApiUrl}/api/v1/DocumentManagement`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    //Save vessel form
    public saveVesselForm(request: SaveVesselFormRequest): Promise<string> {
        return this.requestClientService.post(`${this.documentManagementApi}/SaveVesselForm`, {}, request);
    }

    //Delete vesse document
    public deleteDocument(id: number): Promise<any> {
        return this.requestClientService.post(`${this.documentManagementApi}/DeleteDocument`, {}, { vesselDocumentId: id});
    }
    
    //Delete vessel form
    public deleteForm(id: number): Promise<any> {
        return this.requestClientService.post(`${this.documentManagementApi}/DeleteForm`, {}, { vesselFormId: id});
    }
    
    //download document
    public downloadDocument(id: number, name: string): void {
        window.open(`${this.documentManagementApi}/DownloadDocument?name=${name}&vesselDocumentId=${id}`, "_blank");
    }
    
    //upload document
    public uploadDocument(request: UploadDocumentRequest): Promise<void> {
        return this.requestClientService.postFormData(`${this.documentManagementApi}/UploadDocument`, request);
    }
}
